var footer = document.querySelector(".footer__wrapper");
var footerlinks = footer.querySelector('[href="#open-cookie-settings"]');
footerlinks.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent the default action (navigation) of the link
    privacyBanner.showPreferences();
});


var menu = document.querySelector(".header__menu");
var menuitems = menu.querySelectorAll("li");
var lastMenuItem = menuitems[menuitems.length - 1];
lastMenuItem.classList.add('is--karriere');
var lastlink = lastMenuItem.querySelector("a");

lastlink.addEventListener("click", function(e){
  e.preventDefault();
  window.open("https://karriere.robinlook.de/");
});


// ship to store form manipulation
document.addEventListener('DOMContentLoaded', function () {
  var shipButton = document.querySelector('._ship_to_store');
  if (!shipButton) {
    return; 
  }

  shipButton.addEventListener('click', function(event){
    event.preventDefault();
    
    var form = document.getElementById('shopify-block-ASnRsMmVhUlBnZzBHN__forms_inline_ALH33P');
    if(form.style.display == "block"){
      form.style.display = "none";
    }else{
      form.style.display = "block";
    }
    
    var labels = document.getElementById('app-embed').shadowRoot.querySelectorAll('label');
    for (label of labels) {
      label.style.marginTop = "-8px";
    }
    
    var sourceField = document.querySelector('[name="id"]'); 
    var targetLabel = document.getElementById('app-embed').shadowRoot.getElementById('label-custom#ihre_fassung');
    var targetField = document.getElementById('app-embed').shadowRoot.getElementById('custom#ihre_fassung');
    var targetFieldId = document.getElementById('app-embed').shadowRoot.getElementById('custom#ihre_fassung_id');
    var targetLabelId = document.getElementById('app-embed').shadowRoot.getElementById('label-custom#ihre_fassung_id');

    var storagePlace = document.getElementById('app-embed').shadowRoot.getElementById('custom#lagerplatz');
    var storagePlaceLabel = document.getElementById('app-embed').shadowRoot.getElementById('label-custom#lagerplatz');

    var name = document.querySelector('h1.product__title').innerText;
    var value = sourceField.value;

    targetField.setAttribute("value", name);
    targetField.value = name;
    targetField.dispatchEvent(new Event("input"));

    targetLabel.style.display = "none";
    targetField.style.display = "none";

    targetFieldId.value = value;
    targetFieldId.setAttribute("value", value);
    targetFieldId.dispatchEvent(new Event("input")); 

    targetLabelId.style.display = "none";
    targetFieldId.style.display = "none";

    var place = document.querySelector('._storagePlace').innerText;
    storagePlace.value = place;
    storagePlace.setAttribute("value", place);
    storagePlace.dispatchEvent(new Event("input")); 

    storagePlace.style.display = "none";
    storagePlaceLabel.style.display = "none";
  });
});